import { createReducer, on } from '@ngrx/store';
import { Breadcrumbs } from '../models';
import { SetBreadcrumbs } from './actions';

export const initialState: Breadcrumbs = [];

export const reducer = createReducer(
  initialState,
  on(SetBreadcrumbs, (_, { breadcrumbs }) => breadcrumbs),
);
